import { NavLink, useLocation } from "react-router-dom";

const ICONS: Record<string, string> = {
  // 24x24 outline icons, drawn with stroke="currentColor".
  overview: "M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z",
  planner: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M8 14h2M14 14h2M8 17h2",
  jobs: "M4 8h16v11H4zM9 8V5h6v3M4 13h16",
  hours: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 8v4l3 2",
  doils: "M5 19V9M12 19V5M19 19v-7M3 19h18",
};

/** Phone navigation: a tab bar along the bottom of the screen, in place of the top bar's links (mobile.css). */
export function TabBar({ year }: { year: number }) {
  const { pathname } = useLocation();
  const jobActive = pathname.startsWith("/job/");
  const tabs = [
    { key: "overview", to: `/year/${year}/overview`, label: "Overview" },
    { key: "planner", to: `/year/${year}`, label: "Planner", end: true },
    { key: "jobs", to: `/year/${year}/jobs`, label: "Jobs" },
    { key: "hours", to: `/year/${year}/hours`, label: "Hours" },
    { key: "doils", to: `/year/${year}/doils`, label: "DOILs" },
  ];
  return (
    <nav className="tabbar" aria-label="Main">
      {tabs.map((t) => (
        <NavLink
          key={t.key}
          to={t.to}
          end={t.end}
          className={({ isActive }) => (isActive || (t.key === "jobs" && jobActive) ? "active" : "")}
        >
          <svg
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d={ICONS[t.key]} />
          </svg>
          <span>{t.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
